module.exports = __webpack_public_path__ + "media/src/assets/Images/Phone-00f97e5a935a0fd577d10a3f2ef4a77a.svg";